<template>
  <ut-form :label-width="300">
    <ut-form-item />
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 报警策略名称
      </template>
      <ut-input v-model="name" placeholder="请输入报警策略名称！" style="width:500px;"></ut-input>
    </ut-form-item>

    <ut-form-item label="报警方式" class="_item">
      <ut-checkbox v-model="mailSelected">邮件</ut-checkbox>
      <template v-if="mailSelected">
        <hr>
        <div>
          <span> 第 </span>
          <el-input-number v-model="mail.beginAlarmTimes"
                           size="mini" :min="1"
                           style="width:95px;"
                           controls-position="right" />
          <span> 个报警事件开始，每个事件进行一次邮件通知。</span>
        </div>
        <div style="margin: 10px 0;">
          <span> 从第 </span>
          <el-input-number v-model="mail.beginAggregateTimes"
                           size="mini" :min="1"
                           style="width:95px;"
                           controls-position="right" />
          <span> 个报警事件开始，取消每个事件进行一次邮件通知，开始合并事件进行通知。 </span>

          <div style="padding-left: 15px;">
            <el-button type="text" size="small" @click="mailGroupFn">
              {{mailShowGroupOpt?'关闭聚合配置':'打开聚合配置'}}
            </el-button>
            <span v-if="mailShowGroupOpt" style="padding: 4px 0 0 30px;">
              <span> 每 </span>
              <el-input-number v-model="mail.aggregateCount"
                               size="mini" :min="1"
                               style="width:95px;"
                               controls-position="right" />
              <span> 个事件，合并成一次邮件通知。 </span>
            </span>
          </div>
        </div>
        <div>
          <span> 第 </span>
          <el-input-number v-model="mail.maxAlarmTimes"
                           size="mini" :min="1"
                           style="width:95px;"
                           controls-position="right" />
          <span> 个事件，停止邮件通知。</span>
        </div>
      </template>
    </ut-form-item>

    <ut-form-item label="报警方式" class="_item">
      <ut-checkbox v-model="wechatSelected">微信</ut-checkbox>
      <template v-if="wechatSelected">
        <hr>
        <ut-form-item :label-width="100">
          <template slot="label">
            <span style="color:red">*</span> 微信报警器
          </template>
          <ut-select v-model="wechat.wechatAlarmId" filterable>
            <ut-option v-for="(v,k) in wxOpts" :value="k" :key="k" :label="v.name"></ut-option>
          </ut-select>
        </ut-form-item>
        <div>
          <span> 第 </span>
          <el-input-number v-model="wechat.beginAlarmTimes"
                           size="mini" :min="1"
                           style="width:95px;"
                           controls-position="right" />
          <span> 个报警事件开始，每个事件进行一次微信通知。</span>
        </div>
        <div style="margin: 10px 0;">
          <span> 从第 </span>
          <el-input-number v-model="wechat.beginAggregateTimes"
                           size="mini" :min="1"
                           style="width:95px;"
                           controls-position="right" />
          <span> 个报警事件开始，取消每个事件进行一次信通知，开始合并事件进行通知。 </span>

          <div style="padding-left: 15px;">
            <el-button type="text" size="small" @click="wechatGroupFn">
              {{wechatShowGroupOpt?'关闭聚合配置':'打开聚合配置'}}
            </el-button>
            <span v-if="wechatShowGroupOpt" style="padding: 4px 0 0 30px;">
              <span> 每 </span>
              <el-input-number v-model="wechat.aggregateCount"
                               size="mini" :min="1"
                               style="width:95px;"
                               controls-position="right" />
              <span> 个事件，合并成一次微信通知。 </span>
            </span>
          </div>
        </div>
        <div>
          <span> 第 </span>
          <el-input-number v-model="wechat.maxAlarmTimes"
                           size="mini" :min="1"
                           style="width:95px;"
                           controls-position="right" />
          <span> 个事件，停止微信通知。 </span>
        </div>
      </template>
    </ut-form-item>

    <ut-form-item label="报警方式" class="_item">
      <ut-checkbox v-model="smsSelected">短信</ut-checkbox>
      <div v-if="smsSelected">
        <hr>
        <div>
          <span> 第 </span>
          <el-input-number v-model="sms.beginAlarmTimes"
                           size="mini" :min="1"
                           style="width:90px;"
                           controls-position="right" />
          <span> 个报警事件开始，每个事件进行一次短信通知。</span>
        </div>
        <div style="margin: 10px 0;">
          <span> 第 </span>
          <el-input-number v-model="sms.maxAlarmTimes"
                           size="mini" :min="1"
                           style="width:95px;"
                           controls-position="right" />
          <span> 个事件，停止短信通知。 </span>
        </div>
        <div style="padding-left: 15px;">
          <el-button type="text" size="small" @click="smsShowGroupOpt = !smsShowGroupOpt">
            {{smsShowGroupOpt?'关闭间隔配置':'打开间隔配置'}}
          </el-button>
          <span v-if="smsShowGroupOpt" style="padding: 4px 0 0 30px;">
            <span>每间隔 </span>
            <el-input-number v-model="sms.alarmFrequency"
                             size="mini" :min="1"
                             style="width:95px;"
                             controls-position="right" />
            <span> 个事件，进行一次短信通知。 </span>
          </span>
        </div>
      </div>
    </ut-form-item>

    <ut-form-item label="报警方式" class="_item">
      <ut-checkbox v-model="voiceSelected">语音</ut-checkbox>
      <div v-if="voiceSelected">
        <hr>
        <div>
          <span> 第 </span>
          <el-input-number v-model="voice.beginAlarmTimes"
                           size="mini" :min="1"
                           style="width:95px;"
                           controls-position="right" />
          <span> 个报警事件开始，每个事件进行一次电话通知。</span>
        </div>
        <div style="margin: 10px 0;">
          <span> 第 </span>
          <el-input-number v-model="voice.maxAlarmTimes"
                           size="mini" :min="1"
                           style="width:95px;"
                           controls-position="right" />
          <span> 个事件，停止电话通知。 </span>
        </div>
        <div style="padding-left: 15px;">
          <el-button type="text" size="small" @click="voiceShowGroupOpt = !voiceShowGroupOpt">
            {{voiceShowGroupOpt?'关闭间隔配置':'打开间隔配置'}}
          </el-button>
          <span v-if="voiceShowGroupOpt" style="padding: 4px 0 0 30px;">
            <span>每间隔 </span>
            <el-input-number v-model="voice.alarmFrequency"
                             size="mini" :min="1"
                             style="width:95px;"
                             controls-position="right" />
            <span> 个事件，进行一次电话通知。 </span>
          </span>
        </div>
      </div>
    </ut-form-item>

    <ut-form-item>
      <ut-button @click="goBack">取消</ut-button>
      <ut-button type="primary" @click="submit">保存</ut-button>
    </ut-form-item>

  </ut-form>
</template>

<script>
export default {
  props: {
    pageType: {}
  },
  data () {
    return {
      wxOpts: {},

      name: '',
      mailSelected: false,
      mailShowGroupOpt: false,
      wechatSelected: false,
      wechatShowGroupOpt: false,
      smsSelected: false,
      smsShowGroupOpt: false,
      voiceSelected: false,
      voiceShowGroupOpt: false,

      mail: {
        beginAlarmTimes: 0,
        maxAlarmTimes: 50,
        beginAggregateTimes: 20,
        aggregateCount: 5
      },
      wechat: {
        wechatAlarmId: undefined,
        beginAlarmTimes: 0,
        maxAlarmTimes: 50,
        beginAggregateTimes: 20,
        aggregateCount: 5
      },
      sms: {
        beginAlarmTimes: 20,
        maxAlarmTimes: 50,
        alarmFrequency: 5
      },
      voice: {
        beginAlarmTimes: 50,
        maxAlarmTimes: 100,
        alarmFrequency: 5
      }

    }
  },
  computed: {
    query_id () {
      return this.$route.query.id
    }
  },
  mounted () {
    this.getWXopts()
    if (this.pageType === 'edit') {
      this.getDetail()
    }
  },
  methods: {
    submit () {
      if (!this.name) {
        this.$message.error('请输入报警策略名称')
        return
      }
      let selectLeastOne = false
      const params = { name: this.name }

      if (this.mailSelected) {
        params.mail = this.mail
        selectLeastOne = true
      }

      if (this.wechatSelected) {
        if (!this.wechat.wechatAlarmId) {
          this.$message.error('请选择微信报警器')
          return
        }
        params.wechat = this.wechat
        selectLeastOne = true
      }
      if (this.smsSelected) {
        params.sms = this.sms
        selectLeastOne = true
      }
      if (this.voiceSelected) {
        params.voice = this.voice
        selectLeastOne = true
      }

      if (!selectLeastOne) {
        this.$message.error('请至少选择一个报警方式')
        return
      }

      let url = '/policys/add.htm'
      if (this.pageType === 'edit') {
        url = '/policys/update.htm'
        params.id = this.query_id
      }
      this.$http.post(url, params)
        .then(({ data }) => {
          if (+data.code === 0) {
            this.$message.success('操作成功')
            this.goBack()
          } else {
            throw data.message
          }
        }).catch((err = '') => {
          this.$message.error(err)
        })
    },
    getDetail () {
      const url = `/policys/${this.query_id}/get.htm`
      this.$http.post(url)
        .then(({ data }) => {
          if (data) {
            this.name = data.name
            if (data.mail) {
              this.mailSelected = true
              this.mail.beginAlarmTimes = data.mail.beginAlarmTimes
              this.mail.maxAlarmTimes = data.mail.maxAlarmTimes
              this.mail.beginAggregateTimes = data.mail.beginAggregateTimes
              this.mail.aggregateCount = data.mail.aggregateCount
            }
            if (data.wechat) {
              this.wechatSelected = true
              this.wechat.wechatAlarmId = data.wechat.wechatAlarmId
              this.wechat.beginAlarmTimes = data.wechat.beginAlarmTimes
              this.wechat.maxAlarmTimes = data.wechat.maxAlarmTimes
              this.wechat.beginAggregateTimes = data.wechat.beginAggregateTimes
              this.wechat.aggregateCount = data.wechat.aggregateCount
            }
            if (data.sms) {
              this.smsSelected = true
              this.sms.beginAlarmTimes = data.sms.beginAlarmTimes
              this.sms.maxAlarmTimes = data.sms.maxAlarmTimes
              this.sms.alarmFrequency = data.sms.alarmFrequency
            }
            if (data.voice) {
              this.voiceSelected = true
              this.voice.beginAlarmTimes = data.voice.beginAlarmTimes
              this.voice.maxAlarmTimes = data.voice.maxAlarmTimes
              this.voice.alarmFrequency = data.voice.alarmFrequency
            }
          }
        }).catch((err = '') => {
          this.$message.error(err)
        })
    },
    wechatGroupFn () {
      this.wechatShowGroupOpt = !this.wechatShowGroupOpt
    },
    mailGroupFn () {
      this.mailShowGroupOpt = !this.mailShowGroupOpt
    },
    goBack () {
      this.$router.push({ path: '/policys' })
    },
    getWXopts () {
      const url = '/wechat/queryList.htm'
      this.$http.post(url)
        .then(({ data }) => {
          this.wxOpts = (data || []).reduce((obj, item) => {
            obj[item.id] = item
            return obj
          }, {})
        }).catch((err = '') => {
          this.$message.error(err)
        })
    }
  }
}
</script>

<style lang="less" scoped>
._item {
  /deep/& > .utear-form-item__content {
    width: 500px;
    flex: 0 1 500px;
    padding: 7px 15px;
    border: 1px dashed #777;
    border-radius: 4px;
  }
}
</style>
